import { motion } from "framer-motion";
import { Star, PlayCircle } from "lucide-react";

interface HeroButtonsProps {
  onRegisterClick: () => void;
}

export const HeroButtons = ({ onRegisterClick }: HeroButtonsProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.2, duration: 0.3 }}
      className="flex flex-wrap gap-4 justify-center mt-8"
    >
      <motion.button
        onClick={onRegisterClick}
        whileHover={{ 
          scale: 1.05,
          boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)"
        }}
        whileTap={{ scale: 0.95 }}
        className="bg-primary text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg flex items-center gap-2 group"
      >
        Start Your Journey
        <Star className="w-5 h-5 group-hover:rotate-45 transition-transform" />
      </motion.button>
    </motion.div>
  );
};